import { WebFormModel } from "../core/model";
import { RemoteRequestState } from "../core/remote";
import httpAxiosApi from "../core/axios.errors.handle";
import {
  EvaluateReverseFeeResultInterface,
  PayoutWebModelOptions
} from "webapp/src/components/forms/payout/payout-basics";


export enum PaymentCodeEnum {
  Bitcoin = "bitcoin",
  USDC = "usdc",
  Ethereum = "ethereum",
  Qiwi = "qiwi",
  USDT = "usdt",
  Capitalist = "capitalist",
  Webmoney = "webmoney",
  YandexMoney = "yandex-money",
  Payoneer = "payoneer",
  Papara = "papara",
  Paxum = "paxum",
  Okpay = "okpay",
  Epese = "epese",

  CardsTopUp = "cardtopup",

  Mts = "mts",
  Megafon = "megafon",
  Beeline = "beeline",
  Yota = "yota",
  Tele2 = "tele2",
  UkrainianMobile = "uamobile",
  TinkoffMobile = "tmobile",

  BangladeshBkash = "bdbkash",
  GCash = "phgcash",
  ZaloPay = "zalopayvn",

  RussianCards = "rucards",
  Card2Card = "card2card",
  UkrainianCards = "uacards",
  KazakhstanCards = "kzcards",
  UzbekistanCards = "uzcards",
  AzerbaijanCards = "azcards",

  Wire = "wire",
  SEPA_EUR = "sepaeur",
  Cards = "cards",
  WorldCardsEuro = "cardseur",
  WorldCardsUsd = "cardsusd",
  Worldcards = "cards",

  UnionPay = "unionpay",
  SngCards = "ciscards",

  CapitalistCheque = "cheque",
  BitcoinGold = "bitcoingold",

  // YandexDirect = 'yandex-direct',
  // GoogleAdwords = 'google-adwords',
  // ZaleyCash = 'zaleycash',
  // Recreativ = 'recreativ',
  // MyTarget = 'mytarget',

  Skrill = "skrill",
  Neteller = "neteller",
  PayTM = "paytm",
  IMPS = "imps",

  GeorgiaCards = "gecards",
  TurkeyCards = "trcards",

  ArgentinaBanks = "arbanks",
  BrazilPix = "brpix",
  ColombiaBanks = "cobanks",
  MexicoBanks = "mxbanks",

  Sbp = "sbp",

  Masspayments = "masspayments",

  AfricaBanks = "africabanks",
  AfricaMobile = "africamobile",

  AFRICA_BANKS_GHANA = "africabanks_ghana",
  AFRICA_BANKS_NIGERIA = "africabanks_nigeria",

  AFRICA_MOMO_GHANA = "africamomo_ghana",
  AFRICA_MOMO_KENYA = "africamomo_kenya",
  AFRICA_MOMO_CAMEROON = "africamomo_cameroon",
  AFRICA_MOMO_UGANDA = "africamomo_uganda",
  AFRICA_MOMO_TANZANIA = "africamomo_tanzania",

  //'wex-cheque', 'exmo-cheque',
  //'livecoin-cheque', 'yobit-cheque',
  // PaymentCodeEnum.BitcoinGold,

  // PAGSMILE
  PAGS_BRBANK = "psbrbank",
  PAGS_BRPIX = "psbrpix",
  PAGS_COLOMBIA_WALLET = "pscowallet",

  PAGS_COWALLET_NEQUI = "colombianequi",
  PAGS_COWALLET_TPAGA = "colombiatpaga",

  PAGS_COLOMBIA_BANK = "pscobank",
  PAGS_COLOMBIA_TRANSFIYA = "pscolombiatransfiya",

  PAGS_CHILE_WALLET = "pschilewallet",
  PAGS_CHILE_BANK = "pschilebank",
  PAGS_PERU_BANK = "psperubank",
  PAGS_ECUADOR_BANK = "psecuadorbank",
  PAGS_MXSPEI = "psmxspei",
  PAGS_COSTA_RICA_BANK = "pscostaricabank",
  PAGS_BOLIVIAN_BANK = "psboliviabank",

  INDIA_BANKS = "indiabanks",
  INDONESIA_BANKS = "indonesiabanks",

  SOUTH_KOREA_BANKS = "southkoreabanks",
  MALAYSIA_BANKS = "malaysiabanks",
  THAILAND_BANKS = "thailandbanks",
  INDONESIA_BANKS_SP = "spindonesiabanks",
  IMPS_SP_INDIA_BANKS = "spindiabanks",
}


export const ImplementedPaymentForms = [
  PaymentCodeEnum.Capitalist,
  PaymentCodeEnum.Webmoney,
  PaymentCodeEnum.YandexMoney,
  PaymentCodeEnum.Qiwi,
  PaymentCodeEnum.Bitcoin,
  PaymentCodeEnum.Ethereum,
  PaymentCodeEnum.USDT,
  PaymentCodeEnum.CardsTopUp,

  PaymentCodeEnum.Mts,
  PaymentCodeEnum.Beeline,
  PaymentCodeEnum.Megafon,
  PaymentCodeEnum.TinkoffMobile,
  PaymentCodeEnum.Tele2,
  PaymentCodeEnum.Yota,
  PaymentCodeEnum.UkrainianMobile,

  PaymentCodeEnum.RussianCards,
  PaymentCodeEnum.Card2Card,
  PaymentCodeEnum.Sbp,
  PaymentCodeEnum.UkrainianCards,
  PaymentCodeEnum.KazakhstanCards,
  PaymentCodeEnum.Cards,
  PaymentCodeEnum.WorldCardsEuro,
  PaymentCodeEnum.WorldCardsUsd,
  PaymentCodeEnum.Wire,
  PaymentCodeEnum.SEPA_EUR,
  PaymentCodeEnum.UnionPay,
  PaymentCodeEnum.SngCards,
  PaymentCodeEnum.UzbekistanCards,
  PaymentCodeEnum.AzerbaijanCards,
  PaymentCodeEnum.CapitalistCheque,
  PaymentCodeEnum.GeorgiaCards,
  PaymentCodeEnum.TurkeyCards,
  PaymentCodeEnum.Skrill,
  PaymentCodeEnum.Neteller,
  PaymentCodeEnum.PayTM,
  PaymentCodeEnum.IMPS,
  PaymentCodeEnum.USDC,

  // PaymentCodeEnum.AfricaBanks,
  // PaymentCodeEnum.AfricaMobile,
  PaymentCodeEnum.AFRICA_BANKS_NIGERIA,
  PaymentCodeEnum.AFRICA_BANKS_GHANA,
  PaymentCodeEnum.AFRICA_MOMO_TANZANIA,
  PaymentCodeEnum.AFRICA_MOMO_UGANDA,
  PaymentCodeEnum.AFRICA_MOMO_KENYA,
  PaymentCodeEnum.AFRICA_MOMO_GHANA,
  PaymentCodeEnum.AFRICA_MOMO_CAMEROON,

  PaymentCodeEnum.ArgentinaBanks,
  PaymentCodeEnum.BrazilPix,
  PaymentCodeEnum.ColombiaBanks,
  PaymentCodeEnum.MexicoBanks,

  PaymentCodeEnum.Payoneer,
  PaymentCodeEnum.Papara,
  PaymentCodeEnum.BangladeshBkash,
  PaymentCodeEnum.GCash,
  PaymentCodeEnum.ZaloPay,

  PaymentCodeEnum.PAGS_BRBANK,
  PaymentCodeEnum.PAGS_PERU_BANK,
  PaymentCodeEnum.PAGS_ECUADOR_BANK,
  PaymentCodeEnum.PAGS_COSTA_RICA_BANK,
  // PaymentCodeEnum.PAGS_BRPIX,
  PaymentCodeEnum.PAGS_COLOMBIA_WALLET,
  PaymentCodeEnum.PAGS_COWALLET_NEQUI,
  PaymentCodeEnum.PAGS_COWALLET_TPAGA,
  PaymentCodeEnum.PAGS_COLOMBIA_BANK,
  PaymentCodeEnum.PAGS_COLOMBIA_TRANSFIYA,
  PaymentCodeEnum.PAGS_CHILE_WALLET,
  PaymentCodeEnum.PAGS_MXSPEI,
  PaymentCodeEnum.PAGS_CHILE_BANK,
  PaymentCodeEnum.PAGS_BOLIVIAN_BANK,

  PaymentCodeEnum.INDIA_BANKS,
  PaymentCodeEnum.INDONESIA_BANKS,

  PaymentCodeEnum.MALAYSIA_BANKS,
  PaymentCodeEnum.SOUTH_KOREA_BANKS,
  PaymentCodeEnum.THAILAND_BANKS,
  PaymentCodeEnum.INDONESIA_BANKS_SP,
  PaymentCodeEnum.IMPS_SP_INDIA_BANKS
];

export class PayoutWebModel extends WebFormModel {
  document: any | null = null;

  loaded = false;

  systemName = "";

  evaluatingFeeStatus: RemoteRequestState = new RemoteRequestState();

  splitable = false;

  notificationDefaultValues = {
    notificationChannel: "",
    notificationAddress: "",
    notificationMobile: "",
    notificationLanguage: "ru"
  };

  getRequired() {
    return this.required;
  }

  getValues() {
    return this.values;
  }

  getOptions() {
    return this.options;
  }

  generalDefaultValues = {
    fromAccount: "", amount: "", verificationType: "",
    sendNotification: false, description: "", destinationAccount: "", cardNumber: "",
    autosplit: false,
    version: null
  };

  values: any = {
    ...this.generalDefaultValues,
    ...this.notificationDefaultValues
  };

  options: PayoutWebModelOptions = {
    verification: [],
    notificationChannels: [],
    sourceCurrency: null,
    autosplit: false
  } as PayoutWebModelOptions;

  getSourceAccounts(): any {
    if (!this.options || !this.options.accounts
      || (this.options.accounts.length == 0)
      || !this.options.allaccounts) return [];
    if (!this.options.sourceCurrency) return this.options.accounts;

    let currency: any;
    if (Array.isArray(this.options.sourceCurrency)) currency = this.options.sourceCurrency;
    else currency = [this.options.sourceCurrency];

    const result: any[] = [];
    for (const account of this.options.allaccounts) {
      if (currency.indexOf(account.currency) > -1) result.push(account);
    }
    return result;
  }

  getSourceAccount(): any {
    if (!this.values || !this.values.fromAccount) return null;

    return this.getSourceAccounts().find((account) => account.number == this.values.fromAccount);
  }

  getDestCurrency() {
    if (!this.options?.destCurrency || (this.options?.destCurrency?.length == 0)) return null;
    return Array.isArray(this.options?.destCurrency) ? this.options?.destCurrency[0] : this.options?.destCurrency;
  }

  get sourceAccount() {
    return this.getSourceAccount();
  }

  evaluateReverseFee() {
    this.preSubmit();
    return httpAxiosApi.post("/webapi/finance/payout/evaluateReverseFee?log=valuateReverseFee", {
      call: "evaluateReverseFee",
      system: this.systemName,
      m: this.values
    }).then((response: any) => response.data.model.result as EvaluateReverseFeeResultInterface)
      .catch((axiosError) => {
        if (axiosError.response.status == 422) this.errors.setErrors(axiosError.response.data.model.payoutModel.errors);
        //this.checkAxiosError(axiosError);
        throw axiosError;
      });
  }

  getValuesSignature() {
    if (!this.values) return null;

    return JSON.stringify(this.values);
  }

  evaluateFee() {
    this.preSubmit();
    this.evaluatingFeeStatus.loadStart();
    return httpAxiosApi.post("/webapi/finance/payout/evaluateFee?log=valuateFee", {
      call: "evaluateFee",
      system: this.systemName,
      m: this.values
    }).then((result: any) => {
      this.evaluatingFeeStatus.loadEnd();
      return result.data.model.result;
    }, (axiosError) => {
      this.evaluatingFeeStatus.loadError();
      // this.checkAxiosError(axiosError);
      if (axiosError && (typeof axiosError === "object")) {
        if (axiosError?.response?.status == 422) {
          this.errors.setErrors(axiosError?.response?.data?.model?.payoutModel?.errors);
          console.log("setErrors", axiosError?.response?.data?.model?.payoutModel?.errors);
        }
      }
      // if (axiosError.response.status == 422) this.errors.setErrors(axiosError.response.data.model.payoutModel.errors);
      throw axiosError;
    });
  }

  checkSplit() {
    const srcAccount = this.getSourceAccount();

    if (!srcAccount || !this.values.amount) return Promise.reject();

    return httpAxiosApi.post("/webapi/finance/payout/checkautosplitAmount?log=checkautosplitAmount", {
      m: {
        amount: this.values.amount,
        currency: srcAccount.currency,
        system: this.systemName
      },
      call: "checkautosplitAmount"
    }).then(
      (response) => response.data.result
    );
  }

  evaluateDestinationAmount(destCurrency: string = null): Promise<EstimatedAmountData | null> {
    // console.log("evaluateDestinationAmount", destCurrency);
    const srcAccount = this.getSourceAccount();

    if (!srcAccount) return Promise.reject(new Error("Не удалось рассчитать сумму пополнения."));

    return fetchEstimateAmount(this.systemName, this.values.amount, srcAccount.currency, destCurrency).catch((axiosError) => {
      this.checkAxiosError(axiosError);
      throw axiosError;
    })
  }


  preSubmit() {
  }

  async submit() {
    this.preSubmit();
    try {
      const result = await this.clientValidation();
    } catch (e) {
      return Promise.reject(e);
    }

    return httpAxiosApi.post("/webapi/finance/payout/createDocument?log=createDocument", {
      call: "createDocument",
      system: this.systemName,
      m: this.values
    }).then((response) => {
      this.document = response.data.document;
      return response.data;
    }, (err) => {
      this.checkAxiosError(err);
      throw err;
    });
  }

  load(sourceAccount = "", doc: any = null) {
    return fetchPaymentModel(this.systemName, {
      documentId: doc,
      sourceAccountNumber: sourceAccount,
      version: this.values.version
    }).then((data) => {
      if (data?.model)
        this._setData(data?.model);
      this.loaded = true;
      return data;
    }, (err) => {
      this.loaded = false;
      throw err;
    });
  }

  async clientValidation(): Promise<any> {
  }

  async clientZodValidation(schema = null): Promise<any> {
    console.log("clientZodValidation", schema);
    if (!schema) return true;
    const result = schema.safeParse(this.values);
    if (result.success) {
      this.errors.clear();
      return true;
    } else {
      const formattedErrors = result.error.format();
      const errorMessages: { [key: string]: string } = {};
      for (const key in formattedErrors) {
        if (key !== "_errors") {
          const errorMessage = formattedErrors[key]?._errors?.[0];
          if (errorMessage) {
            errorMessages[key] = errorMessage;
          }
        }
      }

      console.log("clientZodValidation errorMessages", errorMessages);
      this.errors.setErrors(errorMessages);
      return Promise.reject(errorMessages);
    }
  }


}


export type FetchPaymentModelOptionsType = {
  sourceAccountNumber?: string | null,
  documentId?: string | null,
  version?: string | null,
}

export const fetchPaymentModel = (system: string, options: FetchPaymentModelOptionsType = {}) => {
  return httpAxiosApi.post("/webapi/finance/payout/loadModel?log=loadModel", {
    system: system,
    account: options?.sourceAccountNumber || null,
    doc: options?.documentId || null,
    version: options?.version || null
  }, {
    timeout: 180000
  }).then((response: any) => {
    return { ...response.data };
  });
};


export interface EstimatedAmountData {
  amount: number;
  currency: string;
  srcAmount: string;
  srcCurrency: string;
}

export interface EstimateAmountResult {
  success: boolean;
  amount: number;
  currency: string;
  srcAmount: string;
  srcCurrency: string;
  estimated: EstimatedAmountData;
}

export interface EstimateAmountResponse {
  result: EstimateAmountResult;
  payoutModel: any | null;
}

export const fetchEstimateAmount = (system: string, amount: number | string, currency: string, destCurrency: string = null) => {
  return httpAxiosApi.post<EstimateAmountResponse>("/webapi/finance/payout/estimateAmount?log=estimateAmount", {
    amount,
    currency,
    system: system,
    destCurrency,
    call: "estimateAmount" // InUah
  }).then(
    (response): EstimatedAmountData | null => {
      return response.data?.result?.estimated ? {...response.data?.result?.estimated} : null;
    },
  );
}
